import { useEffect, useState } from "react";
import { Form, Input, Button } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// Substitua por seus componentes reais:
import { Wrapper, Container, Title, Paragraph, SuccessMessage } from "./styles";
import { useIndicacaoParceiro } from "./hooks/useIndicacaoParceiro";
import { useMessage } from "../../uteis/mensagens/useMessage";

export default function ViewJuridico() {
  const [form] = Form.useForm();
  const [enviado, setEnviado] = useState(false);
  const [data, setData] = useState<any>({});

  const { showSuccess, showError, contextHolder } = useMessage();

  const { cadastrar, error, success, resetSuccess, resetError, isLoading } =
    useIndicacaoParceiro();

  const juridicoChange = (changedValues: Partial<any>, allValues: any) => {
    setData(allValues);
  };

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  useEffect(() => {
    // Monta mensagem
    const mensagem = `Olá! Sou multiproprietário e fui indicado pela Multicotas. Gostaria de orientação jurídica. Nome: ${data.nome} | WhatsApp: ${data.celular}`;
    const numeroEscritorio = "5511941553586";

    // Exibe a mensagem de sucesso
    if (success && !successDisplayed) {
      localStorage.setItem("indicacaoJuridica", JSON.stringify(data));
      showSuccess(success);
      setSuccessDisplayed(true);
      setTimeout(() => {
        resetSuccess();
        setSuccessDisplayed(false);

        // Redireciona
        window.location.href = `https://wa.me/${numeroEscritorio}?text=${encodeURIComponent(
          mensagem
        )}`;
      }, 2000);
      setEnviado(true);
    }

    // Exibe a mensagem de erro
    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      // Limpa estado de error após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    error,
    success,
    resetSuccess,
    resetError,
    data,
    errorDisplayed,
    successDisplayed,
  ]);

  return (
    <Wrapper>
      {contextHolder}
      <Container>
        <Title>⚖️ Precisa de ajuda jurídica?</Title>
        <Paragraph>
          Temos parceria com um escritório especializado. Preencha abaixo e você
          será direcionado.
        </Paragraph>

        {!enviado ? (
          <Form
            form={form}
            onValuesChange={(changedValues, allValues) =>
              juridicoChange(changedValues, allValues)
            }
            onFinish={() => {
              cadastrar(data);
            }}
            layout="vertical"
          >
            <Form.Item
              name="nome"
              label="Nome"
              className="formItems"
              hasFeedback
              validateTrigger="onBlur"
              rules={[
                { required: true, message: "O nome é obrigatório" },
                {
                  min: 3,
                  message: "O nome deve ter no mínimo 3 caracteres",
                },
              ]}
            >
              <Input placeholder="Digite seu nome" />
            </Form.Item>

            <Form.Item
              name="celular"
              label="Celular"
              className="formItems"
              rules={[{ required: true, message: "O celular é obrigatório" }]}
            >
              <PhoneInput
                country="br"
                onChange={(value) => form.setFieldsValue({ celular: value })}
                placeholder="Digite o número do seu celular"
                inputClass="phone-input"
              />
            </Form.Item>

            <Button type="primary" htmlType="submit">
              📲 Falar com o escritório parceiro
            </Button>
          </Form>
        ) : (
          <SuccessMessage>Você está sendo redirecionado...</SuccessMessage>
        )}
      </Container>
    </Wrapper>
  );
}
